import axios from "axios"

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL

const buildUrl = (path: string) => {
  if (API_BASE_URL) {
    return `${API_BASE_URL.replace(/\/$/, "")}${path}`
  }
  return path
}

export interface PagedResultDto<T> {
  items: T[]
  pageNumber: number
  pageSize: number
  totalItems: number
  totalPages: number
}

export interface UserAdminDto {
  userId: string
  tenantId: string
  tenantIds?: string[]
  username?: string | null
  fullName?: string | null
  email?: string | null
  position?: string | null
  phone?: string | null
  userType?: string | null
  authProvider?: string | null
  companyId?: string | null
  companyName?: string | null
  profileMapping?: string | null
  remark?: string | null
  isActive: boolean
  createdAt?: string | null
  updatedAt?: string | null
}

export interface UserSearchParams {
  tenantId: string
  search?: string
  userType?: string
  authProvider?: string
  profileMapping?: string
  isActive?: boolean
  page?: number
  pageSize?: number
}

export interface UserUpsertRequest {
  tenantId: string
  tenantIds?: string[]
  username: string
  fullName: string
  email?: string | null
  position?: string | null
  phone?: string | null
  userType?: string | null
  authProvider?: string | null
  companyId?: string | null
  profileMapping?: string | null
  remark?: string | null
  password?: string | null
  isActive: boolean
}

export interface UserSetActiveRequest {
  isActive: boolean
  remark?: string | null
  tenantId?: string
  tenantIds?: string[]
}

export async function searchUsers(params: UserSearchParams): Promise<PagedResultDto<UserAdminDto>> {
  const response = await axios.get<PagedResultDto<UserAdminDto>>(buildUrl("/api/v1/users"), {
    params,
  })
  return response.data
}

export async function createUser(payload: UserUpsertRequest): Promise<UserAdminDto> {
  const response = await axios.post<UserAdminDto>(buildUrl("/api/v1/users"), payload)
  return response.data
}

export async function updateUser(userId: string, payload: UserUpsertRequest): Promise<UserAdminDto> {
  const response = await axios.post<UserAdminDto>(buildUrl(`/api/v1/users/${userId}`), payload)
  return response.data
}

export async function setUserActive(userId: string, payload: UserSetActiveRequest): Promise<UserAdminDto> {
  const response = await axios.post<UserAdminDto>(buildUrl(`/api/v1/users/${userId}/active`), payload)
  return response.data
}
